import { observer } from 'mobx-react'
import React, { useEffect } from 'react'
import { ButtonToolbar } from 'react-bootstrap'
import { useForm, UseFormReturn } from 'react-hook-form'
import { McPageAlert } from 'src/Components'
import McButton from 'src/Components/McButton'
import McModal from 'src/Components/Modals/McModal'
import { MyTextbox } from 'src/Components/My'
import { t } from 'src/I18n'
import { IFormValues, linkSamStore } from './Store'

interface IProps {
  onClose: () => void
  onSubmitSuccess: () => void
  terminalId: string
}

interface IProps {}
const LinkSamModal: React.FC<IProps> = ({
  onClose,
  onSubmitSuccess,
  terminalId,
}) => {
  useEffect(() => {
    linkSamStore.Initialize()
  }, [null])

  const { IsSubmitting, PageAlert } = linkSamStore

  const useFormProps: UseFormReturn<IFormValues> = useForm<IFormValues>({})
  const { handleSubmit } = useFormProps

  const close = () => {
    if (!linkSamStore.IsSubmitting) {
      onClose()
    }
  }

  const onSubmit = (data: IFormValues) => {
    linkSamStore.LinkSam(data.SamId, terminalId).then(() => {
      onSubmitSuccess()
      close()
    })
  }

  return (
    <form className="parsley-form" onSubmit={handleSubmit(onSubmit)}>
      <McModal
        title={t.sam.link.title}
        footer={
          <div>
            <McPageAlert pageAlert={PageAlert} />
            <ButtonToolbar className="pull-right">
              <McButton onClick={() => close()}>{t.common.cancel}</McButton>
              <McButton
                bsStyle="primary"
                type="submit"
                isLoading={IsSubmitting}
              >
                {t.common.save}
              </McButton>
            </ButtonToolbar>
          </div>
        }
        closeClicked={() => close()}
      >
        <MyTextbox
          formObject={{} as IFormValues}
          label={t.sam.link.samId.label}
          name="SamId"
          useFormProps={useFormProps}
          rules={{
            required: t.sam.link.samId.errors.required,
          }}
          tabIndex={1}
          type="number"
        />
      </McModal>
    </form>
  )
}

export default observer(LinkSamModal)
